<template>
  <div>
    <div class="roomChange">
      <div class="subTitle">原住房信息</div>
      <div class="padding-20 bg-fff">
          <div class="listBox">
            <img class="thumbnail" :src="Url + pageDate.photoUrl">
            <div class="mesList">
              <div class="title color-333 font-size-14px margin-top-8">姓名：{{pageDate.studentName}}</div>
              <p class="color-666 font-size-26 margin-top-8">学号：{{pageDate.studentNo}}</p>
              <p class="color-666 font-size-26 margin-top-8">学院：{{pageDate.college}}</p>
              <p class="color-666 font-size-26 margin-top-8">当前年级：{{pageDate.classYear}}级</p>
              <p class="color-666 font-size-26 margin-top-8">房间号：{{pageDate.roonName}}</p>
            </div>
          </div>
        </div>
        <div class="subTitle margin-top-20">选择换房目标</div>
        <div class="exchageRoom">
          <div>
            <div class="pickerBoxs">
              <span class="font-size-14px">选择楼栋</span>
              <div class="dropdownBox">
                <div id="buildDropdown" :class="{'color-999': !buildData.value}" class="dropdown font-size-14px">{{buildData.name}}</div>
                <img class="dropArrow" src="static/images/arrow-right.png">
              </div> 
            </div>
            <div class="pickerBoxs">
              <span class="font-size-14px">选择房间</span>
              <div class="dropdownBox">
                <div id="roomDropdown" :class="{'color-999': !roomData.value}" class="dropdown font-size-14px">{{roomData.name}}</div>
                <img class="dropArrow" src="static/images/arrow-right.png">
              </div> 
            </div>
          </div>
          <div class="quedingBtn" @click="quedingBtn()">确定</div>
        </div>

        <div class="subTitle margin-top-20">目标房间住宿情况</div>
        <div class="grid bg-appStyle color-fff">
          <div class="gridWarp nopadding noborder">
            <div class="gridCell flex-basis-60">
              床位
            </div>
            <div class="gridCell flex-1">
              姓名
            </div>
            <div class="gridCell flex-1">
              学号
            </div>
            <div class="gridCell flex-1">
              学院
            </div>
          </div>
        </div>
        <div class="grid bg-fff nopadding" v-if="list.length > 0">
          <div class="gridWarp" v-for="(item, index) in list" :key="index">
            <div class="gridCell flex-basis-60">
              <div>{{item.bedName}}</div>
            </div>
            <div class="gridCell flex-1">
              <div>{{item.studentName}}</div>
            </div>
            <div class="gridCell flex-1">
              <div v-html="item.studentNo"></div>
            </div>
            <div class="gridCell flex-1">
              <div>{{item.college}}</div>
            </div>
          </div>
        </div>
        <div class="subTitle margin-top-20">添加审批表照片</div>
        <!-- 添加照片 -->
        <div class="form-group">
          <div class="control-form">
            <ul class="upload-imgs">
              <li v-if="imgLen>=1 ? false : true">
                <form enctype="multipart/form-data">
                  <input capture="camera" name="file" class="upload" @change="addImg" type="file" ref="inputer" accept="image/jpg,image/jpeg,image/png,image/gif,image/bmp">
                </form>
                
                <!-- <a class="add"><i class="iconfont icon-plus"></i><p>点击上传</p></a> -->
                <img class="imgAdd" src="static/images/imgAdd.png">
                <p class="margin-top-20">点击上传</p>
              </li>
              <li v-for="(value, key) in imgs" :key="key">
                <p class="img"><img :src="getObjectURL(value)"><a class="close" @click="delImg(key)">×</a></p>
              </li>
            </ul>
          </div>
        </div>
        <div class="subTitle margin-top-20">换寝原因</div>
        <div class="bg-fff">
          <textarea  class="HqTextarea font-size-28 color-999 full-width margin-top-10" elastic placeholder="请填写换寝原因"
        maxlength="100" v-model="textarea"></textarea>
        </div>
        
        <div class="subTitle margin-top-20">添加学生手机号码</div>
        <div class="bg-fff">
          <input type="number" class="telPhone" placeholder="请填写学生手机号" name="telPhone" v-model="telPhone"/>
        </div>
        
        <div class="margin-bottom"></div>

    </div>
    <div class="footerBtn" @click="submit()">提交换寝</div>
  </div>
</template>

<script>

import Vue from 'vue'
import { mapGetters } from "vuex";
import { Toast } from 'mint-ui';
import MobileSelect from 'mobile-select';

import service from "@/fetch/service";
import * as types from '@/vuex/types';
import {checkPhone} from '@/util/filter'

import axios from 'axios'

import VueResource from 'vue-resource'


Vue.use(VueResource);
export default {
  components: {},
  data() {
    return {
      Url: types.URL,
      buildDataArr: [
        {
          id: '',
          value: '请选择目标楼栋'
        }
      ],
      buildData: { //当前下拉框的值
        name: '请选择目标楼栋',
        value: ''
      },
      roomDataArr: [
        {
          id: '',
          value: '请选择目标房间'
        }
      ],
      roomData: { //当前下拉框的值
        name: '请选择目标房间',
        value: ''
      },
      isChooseRoom: false,
      list: [],
      formData:new FormData(),
      imgs: {},
      imgLen:0,
      imgsUrl:'',
      imgsId:'',
      textarea: '',
      telPhone: ''
    };
  },
  created() {
    this.getOwnDorm()
  },
  computed:{
    ...mapGetters([]),
    pageDate: {
      // getter
      get: function () {
          return this.$route.query.pageDate;
      }
    }
  },
  mounted() {
    let that = this
    
    that.mobileSelect2 = new MobileSelect({
        trigger: "#roomDropdown",
        title: "请选择目标楼栋",
        wheels: [
          {data: that.roomDataArr}
        ],
        triggerDisplayData: false,
        callback:function(indexArr, data){
            console.log(data);
            that.roomData = {
              name: data[0].value,
              value: data[0].id
            }
        }
    });
  },
  watch: {
    'selected': function() {
      this.list = [];
      this.searchValue = '';
      this.loadTop();
    }
  },
  methods: {
    //获取社区老师管辖的楼栋
    getOwnDorm() {
      let that = this
      this.$store.dispatch("setLoadingState", true);
      service
      .findOwnDorm()
      .then(res => {
        this.$store.dispatch("setLoadingState", false);
        let result = res.result;
        if (res.success) {
          that.buildDataArr = [
            {
              id: '',
              value: '请选择目标楼栋'
            }
          ];
          that.buildData = { //当前下拉框的值
            name: '请选择目标楼栋',
            value: ''
          };
          result.forEach(element => {
            that.buildDataArr.push({
             id: element.id,
             value: element.name 
            })
          });
          var mobileSelect1 = new MobileSelect({
            trigger: "#buildDropdown",
            title: "请选择目标楼栋",
            wheels: [
              {data: that.buildDataArr}
            ],
            callback:function(indexArr, data){
                console.log(data);
                that.buildData = {
                  name: data[0].value,
                  value: data[0].id
                }
                that.roomDataArr = [
                  {
                    id: '',
                    value: '请选择目标房间'
                  }
                ];
                that.roomData = { //当前下拉框的值
                  name: '请选择目标房间',
                  value: ''
                };
                that.mobileSelect2.updateWheel(0, that.roomDataArr) //重新渲染全部wheel数据 仅含联动数据
                
                // 重新定位第1个轮子的位置，将第1个轮子的第0个数据改为当前选中。
                // (第1个轮子是指右边的轮子，左边的轮子是第0个)
                that.mobileSelect2.locatePosition(0, 0);
                if (that.buildData.value) {
                  //获取房间
                  that.findNotFullInRoomByAreaId(data);
                }
                
            }
          });
          
        }
        
      })
      .catch(error => {
        this.$store.dispatch("setLoadingState", false);
        console.log(error);
        Toast(error.data.msg);
      });
    },
    //获取房间
    findNotFullInRoomByAreaId() {
      let that = this
      this.$store.dispatch("setLoadingState", true);
      service
      .findNotFullInRoomByAreaId({
        areaId: that.buildData.value
      })
      .then(res => {
        this.$store.dispatch("setLoadingState", false);
        let result = res.result;
        if (res.success) {
          result.forEach(element => {
            that.roomDataArr.push({
             id: element.roomId,
             value: element.roomName 
            })
          });
          console.log(that.roomDataArr)
          that.mobileSelect2.updateWheel(0, that.roomDataArr) //重新渲染全部wheel数据 仅含联动数据
        }
        
      })
      .catch(error => {
        this.$store.dispatch("setLoadingState", false);
        console.log(error);
        Toast(error.data.msg);
      });
    },
    //根据寝室id查询这个寝室的入住的人员信息
    findNotFullInRoomPersons() {
      let that = this
      this.$store.dispatch("setLoadingState", true);
      service
      .findNotFullInRoomPersons({
        roomId: that.roomData.value
      })
      .then(res => {
        this.$store.dispatch("setLoadingState", false);
        let result = res.result;
        if (res.success) {
          that.isChooseRoom = true;
          that.list = res.result;
          res.result.forEach(element => {
            element.studentName = element.studentName.slice(0,4)
            element.college = element.college.slice(0,6)
            element.studentNo = this.lineFourText(element.studentNo, 8)
          });
        }
        
      })
      .catch(error => {
        this.$store.dispatch("setLoadingState", false);
        console.log(error);
        Toast(error.data.msg);
      });
    },
    //确定房间选择
    quedingBtn() {
      let that = this 
      if (that.roomData.value && that.buildData.value) {
        that.findNotFullInRoomPersons();
      }else {
        Toast("请选择楼栋和房间");
      }
    },
    //图片选择
    addImg(event){
      let inputDOM = this.$refs.inputer;
      // 通过DOM取文件数据
      this.fil = inputDOM.files;
      console.log('this.fil:',this.fil[0])
      console.log('event.target.files[0]', event.target.files[0])
      let formData = new FormData(); //创建form对象
      formData.append('file', this.fil[0]); //通过append向form对象添加数据
      formData.append('fileSaveDir', 'changeRoom'); //通过append向form对象添加数据
      console.log(formData.get('file')); //FormData私有类对象，访问不到，可以通过get判断值是否传进去
      // console.log(this.$http)
      this.$store.dispatch("setLoadingState", true);
      this.$http.post(types.URL + '/sys/attach/upLoad', formData,{
          headers: {
            'Content-Type': 'multipart/form-data',
            'token': sessionStorage.getItem('token')
          }
        }).then(datas => {
          this.$store.dispatch("setLoadingState", false);
          console.log(datas)
          let oldLen= this.imgLen;
          let len = this.fil.length+oldLen;
          this.imgLen++;
          this.$set(this.imgs,this.fil[0].name+'?'+new Date().getTime(),this.fil[0]);
          let res = datas.body;
          if (res.success) {
            this.imgsId = res.result.id[0]
          }else {
            Toast(res.msg);
          }

        });
    },
    getObjectURL(file) {
      var url = null ;
      if (window.createObjectURL!=undefined) { // basic
        url = window.createObjectURL(file) ;
      } else if (window.URL!=undefined) { // mozilla(firefox)
        url = window.URL.createObjectURL(file) ;
      } else if (window.webkitURL!=undefined) { // webkit or chrome
        url = window.webkitURL.createObjectURL(file) ;
      }
      this.imgsUrl = url
      return url ;
    },
    delImg(key){
      this.$delete(this.imgs,key);
      this.imgLen--;
      this.imgsId = '';
    },
    submit(){
      let that = this
      if (!that.roomData.value || !that.isChooseRoom) {
        Toast("请选择房间");
        return;
      }
      if (!that.imgsId) {
        Toast("请上传审批表图片");
        return;
      }
      if (!that.textarea) {
        Toast("请填写换寝原因");
        return;
      }
      if (!that.telPhone) {
        Toast("请填写学生手机号");
        return;
      }else {
        if (!checkPhone(that.telPhone)) {
          Toast("请填写正确的手机号");
          return;
        }
      }
      this.$store.dispatch("setLoadingState", true);
      service
      .sqApply({
        studentId: that.pageDate.studentId,
        newRoomId: that.roomData.value,
        attrId: that.imgsId,
        phone: that.telPhone,
        reason: that.textarea
      })
      .then(res => {
        this.$store.dispatch("setLoadingState", false);
        if (res.success) {
          Toast(res.msg);
          setTimeout(() => {
            this.$router.go(-1);
          }, 500);
        }
        
      })
      .catch(error => {
        this.$store.dispatch("setLoadingState", false);
        console.log(error);
        Toast(error.msg);
      });
      
    },
    //一行只能显示4个字 多余的换行
    lineFourText: function (str, num) {
      if (!str) return ''
      let newStr = ''
      for (let index = 0; index < str.length; index++) {
        newStr += str[index]
        if ((index + 1) % num == 0) {
          newStr += '<br />'
        }
      }
      return newStr
    },
    loadBottom: function(){//上拉加载更多
      console.log("上拉加载更多");
      this.more();                 
      this.$refs.loadmore.onBottomLoaded();
    },
    loadTop: function(){//下拉刷新
      this.pageNo =1;
      this.loaddata();               
      this.$refs.loadmore.onTopLoaded();
    },
    getDatas1() {
      this.$store.dispatch("setLoadingState", true);
      service
      .findInRoomByCollegeList({
        "dormAreaId": this.buildingData.value, //楼栋id,默认查全部传null
        "classYear": this.gradeData.value, //年级，默认查全部传null
        "sex": this.genderData.value, //性别[1男生 2女生]，默认查全部传null
        "studentCnt":  this.peopleNumberData.value, //人数，1，2，3，4 默认查全部传null
        "page": this.pageNo,
        "limit": this.pageSize
      })
      .then(res => {
        console.log(res);
        this.$store.dispatch("setLoadingState", false);
        let result = res.result;
        console.log(this.allLoaded);
        if (res.success) {
        }
        
      })
      .catch(error => {
        this.$store.dispatch("setLoadingState", false);
        console.log(error);
        Toast(error.data.msg);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/css/function";
$them-color: #03a9f4;
.footerBtn {
  width: 100%;
  height: px2rem(100px);
  background: $them-color;
  // position: fixed;
  // bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 14px;
}
.roomChange {
  
  background: #f5f5f5;
  .font-size-14px{
    font-size: 14px;
  }
  .flex-basis-60 {
    flex-basis: px2rem(110px) !important;
    padding: 0 px2rem(10px);
  }
  padding: px2rem(20px);
  .subTitle {
    font-size: 14px;
    padding: px2rem(20px);
    font-weight: bold;
  }
  .exchageRoom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: px2rem(20px) px2rem(20px);
    background: #fff;
    .pickerBoxs {
      display: flex;
      font-size: 14px;
      margin-top: px2rem(20px);
      align-items: center;
      .dropdownBox {
        margin-left: px2rem(20px);
        display: flex;
        border: 1px solid #bbbbbb;
        align-items: center;
        padding: 0 px2rem(5px);
        .dropdown {
          padding: px2rem(20px) px2rem(10px);
          width: px2rem(250px);
        }
        .dropArrow {
          width: px2rem(40px);
          height: px2rem(40px);
        }
      }
    }
    .quedingBtn {
      width: px2rem(150px);
      height: px2rem(50px);
      line-height: px2rem(50px);
      background: #03a9f4;
      align-self: center;
      border-radius: px2rem(10px);
      text-align: center;
      color: #fff;
    }
  }
  ////图片上传样式 ------start添加图片
  .upload-imgs{
    margin: 0 px2rem(20px);
    overflow: hidden;
    font-size: 0;
    background: #fff;
    padding: px2rem(20px) px2rem(10px);
  }
  .upload-imgs li{
    position: relative;
    width: px2rem(200px);
    height: px2rem(200px);
    font-size: 14px;
    display: inline-block;
    padding: px2rem(20px);
    margin-right: px2rem(15px);
    border: 1px dashed $them-color;
    text-align: center;
    vertical-align: middle;
  }
  // .upload-imgs li:hover{
  //   border-color: $them-color;
  // }
  .upload-imgs .imgAdd {
    width: px2rem(100px);
    height: px2rem(100px);
  }
  .upload-imgs .add{
    display: block;
    background-color: $them-color;
    width: px2rem(200px);
    height: px2rem(200px);
  }
  .upload-imgs .add .iconfont{
    padding: 10px 0;
    font-size: 40px;
  }
  // .upload-imgs li:hover .add{
  //   background-color: $them-color;
  // }
  .upload-imgs li .upload{
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1;
    width: px2rem(200px);
    height: px2rem(300px);
    padding: px2rem(20px);
    margin-top: px2rem(-100px);
  }
  .upload-imgs .img,
  .upload-imgs .img img{
    position: relative;
    width: px2rem(200px);
    height: px2rem(200px);
    line-height: px2rem(200px);
  }
  .upload-imgs .img img{
    vertical-align: middle;
  }
  .upload-imgs .img .close{
    display: none;
  }
  .upload-imgs li .img .close{
    display: block;
    position: absolute;
    right: 0;
    top: 0;
    line-height: 1;
    font-size: px2rem(60px);
    color: #fff;
  }
  //图片上传样式 ------end
  //换寝原因
  .HqTextarea {
    width: px2rem(500px);
    height: px2rem(150px);
    border-radius: px2rem(15px);
    padding: px2rem(20px);
    border: none;
  }
  .telPhone {
    width: px2rem(500px);
    height: px2rem(60px);
    border-radius: px2rem(15px);
    padding: px2rem(20px);
  }
  .margin-bottom {
    margin-bottom: px2rem(100px);
  }
  .listBox {
    .bg-f9b625 {
      background: #f9b625;
    }
    display: flex;
    //缩略图
    .thumbnail {
        width: px2rem(136px);
        height: px2rem(136px);
        margin-right: px2rem(30px);
        border-radius: px2rem(5px);
    }
    //缩略图-长方形
    .thumbnail-max {
        width: px2rem(210px);
        height: px2rem(136px);
        margin-right: px2rem(26px);
        border-radius: px2rem(5px);
    }
    //基本信息栏
    .mesList {
        flex: 1;
        .title {
            display: flex;
            align-items: center;
            flex: 1;
            //列表 标签
            .label {
                flex: none;
                display: inline-block;
                padding: 0 px2rem(15px);
                height: px2rem(32px);
                line-height: px2rem(32px);
                color: #fff;
                border-radius: px2rem(3px);
                margin-right: px2rem(16px);
                margin-left: px2rem(20px);
                font-size: px2rem(22px);
            }
        }
        //标签靠右-标签
        .title-label-right {
            justify-content: space-between;
        }
        p {
            color: #666;
            font-size: px2rem(26px);
            margin-top: px2rem(25px);
        }
    }
  }
}
</style>


// WEBPACK FOOTER //
// RoomChange.vue?9dab42d4